/* ==================================================================
   FLUID NAVIGATION — departure side
   ------------------------------------------------------------------
   Arrival is handled entirely in CSS (see transition.css) so it cannot
   get stuck. This file only holds the page back long enough to play
   the departure, then hands over to the browser.

   Anything that is not an ordinary same-origin left-click is left
   completely alone: new tabs, downloads, mailto/tel, external hosts,
   in-page anchors, and modified clicks all navigate normally.
   ================================================================== */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Coming back via the back button can restore the page from bfcache
     mid-departure, with the veil still closed. Always reopen on show. */
  function reopen() {
    root.classList.remove('hp-leaving', 'hp-focus');
    var flying = document.querySelector('.hp-flying');
    if (flying) flying.classList.remove('hp-flying');
  }
  window.addEventListener('pageshow', reopen);
  window.addEventListener('popstate', reopen);

  if (reduced) return;   // no interception at all; navigate instantly

  function shouldIntercept(e, a) {
    if (e.defaultPrevented) return false;
    if (e.button !== 0) return false;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return false;
    if (!a || a.hasAttribute('download')) return false;

    var target = a.getAttribute('target');
    if (target && target !== '_self') return false;

    var href = a.getAttribute('href');
    if (!href || href.charAt(0) === '#') return false;
    if (/^(mailto:|tel:|sms:|javascript:)/i.test(href)) return false;

    var url;
    try { url = new URL(a.href, window.location.href); } catch (err) { return false; }
    if (url.origin !== window.location.origin) return false;

    // Pure in-page anchor — let the browser scroll, don't veil the page.
    if (url.pathname === window.location.pathname &&
        url.search === window.location.search && url.hash) return false;

    return url;
  }

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a') : null;
    if (!a) return;

    var url = shouldIntercept(e, a);
    if (!url) return;

    e.preventDefault();

    /* If the click landed on a portrait, that portrait leads: it grows
       while the rest of the wall clears. Otherwise it is a plain
       dissolve. */
    var piece = a.classList.contains('salon-card') ? a
              : (a.closest('.salon-card') || a.closest('.mw-piece'));

    /* Timing is the whole feel here. When a portrait leads, it needs a
       real beat on screen — growing while the rest of the wall clears —
       before the veil starts closing over it, otherwise the motion is
       there but nobody ever sees it. */
    var veilDelay = 0;
    var wait = 380;

    if (piece) {
      piece.classList.add('hp-flying');
      root.classList.add('hp-focus');
      veilDelay = 260;   // watch the portrait first
      wait = 720;        // 260 + 420 close, then go
    }

    if (veilDelay) {
      setTimeout(function () { root.classList.add('hp-leaving'); }, veilDelay);
    } else {
      root.classList.add('hp-leaving');
    }

    setTimeout(function () { window.location.href = url.href; }, wait);
  });
}());
